import { getActivitiesWithinRange } from "../utils/activity.utils";

import type { JWTToken, Activity } from "@packages/client";

export const requestActivity = async (
  endpoint: string,
  accessToken: { access_token: string },
  from?: string | number | Date,
  to?: string | number | Date
) => {
  let _endpoint = endpoint;

  if (from && to) {
    _endpoint = `${endpoint}&after=${new Date(
      from
    ).toISOString()}&before=${new Date(to).toISOString()}`;
  }

  const response = await fetch(_endpoint, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken.access_token}`
    }
  });
  const jsonResponse = await response.json();

  return jsonResponse;
};

export const fetchActivitiesInRange = async (
  endpoint: string,
  accessToken: JWTToken,
  from: string | number | Date,
  to: string | number | Date
) => {
  const recurseFetch = async (
    from: string | number | Date,
    to: string | number | Date,
    activities: Activity[] = []
  ): Promise<Activity[]> => {
    try {
      const result = await requestActivity(endpoint, accessToken, from, to);
      if (!result.length) return activities;
      const lastItem = result[result.length - 1];
      return await recurseFetch(from, lastItem.created_at, [
        ...activities,
        ...result
      ]);
    } catch {
      return activities;
    }
  };
  const activities = await recurseFetch(from, to, []);

  return getActivitiesWithinRange(
    activities,
    new Date(from).getTime(),
    new Date(to).getTime() || Date.now()
  );
};
